import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
} from "@apollo/client";

export const client = new ApolloClient({
  link: createHttpLink({
    uri: `https://graph.emzioi.com/graphql/`,
  }),
  cache: new InMemoryCache(),
});
